<template>
  <el-dialog
    title="会员积分明细"
    :visible.sync="visible"
    append-to-body=""
    width="600px"
    @closed="handleClosed">
    <p style="margin-bottom: 10px;">当前积分:<span style="margin-left: 30px;">{{ info.totalPoints }}</span></p>
    <el-table
      v-loading="loading"
      border
      :data="list"
      height="300">
      <el-table-column
        prop="doneTime"
        label="时间">
        <template slot-scope="scope">
          <span>{{ scope.row.doneTime | dateformat("YYYY-MM-DD HH:mm:ss") }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="busiType"
        label="积分类型">
        <template slot-scope="scope"> {{ busiType[scope.row.busiType] }} </template>
      </el-table-column>
      <el-table-column
        prop="curPoints"
        label="积分">
        <template slot-scope="scope"> {{ scope.row.curPoints }} </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top: 10px;text-align: center;"
      background
      :current-page.sync="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="totalNum"
      @current-change="handleCurrentChange">
    </el-pagination>
    <div slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'MemberIntegralModal',
  filters: {
    busiTypeFormat(value) {
      return this.busiType[value]
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      busiType: {
        1: '消费赠送',
        2: '支付赠送',
        3: '评价赠送',
        4: '已过期',
        5: '积分折现',
        6: '积分兑换',
        7: '抽奖',
        8: '步数兑换',
        9: '扫码赠送',
        10: '签到赠送',
        11: '完善资料',
        13: '邀请好友'
      },
      info: {},
      list: [],
      totalNum: 0,
      config: {
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.info = {}
      this.list = []
      this.totalNum = 0
      this.config = {
        pageNum: 1,
        pageSize: 10
      }
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    fetchList(vendorId, userId) {
      this.loading = true
      this.$store.dispatch('member/getpointsdetails', {
        payload: {
          ...this.config,
          vendorId,
          userId
        },
        success: res => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(vendorId, userId, row) {
      this.info = row
      this.toggleModal(true)
      this.fetchList(vendorId, userId)
    }
  }
}
</script>
